import React from "react";
import * as S from "../css/Barcode.styles";
import MenuComponent from "../component/MenuComponent";
import BarcodeListsComponent from "../component/barcode/BarcodeListsComponent";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { orderInfoIsViewState } from "../stores/barcode/orderInfoIsViewState";
import { PrimeReactProvider } from "primereact/api";
import { barcodeTrackingState } from "../stores/barcode/barcodeTrackingState";
import { useNavigate } from "react-router-dom";
import { isInvoiceBarcodeState } from "../stores/vass/isInvoiceBarcodeState";
import { loginState } from "../stores/loginState";
import { barcodeDataState } from "../stores/barcode/barcodeDataState";
import { trackingValueState } from "../stores/barcode/trackingValueState";
import useGetImgUrl from "../api/barcode/useGetImgUrl";

function Barcode(props) {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const orderInfoIsView = useRecoilValue(orderInfoIsViewState); // 화물추적 표시여부
  const trackingList = useRecoilValue(barcodeTrackingState); // 화물추적 데이터
  const barcodeData = useRecoilValue(barcodeDataState); // 운송장 리스트 조회 시의 모든 운송장 정보
  const trackingValue = useRecoilValue(trackingValueState); // 선택 된 운송장에 대한 번호, 날짜
  const setIsInvoice = useSetRecoilState(isInvoiceBarcodeState); // 화물추적에서 영상 추적 버튼 클릭 시 영상추적 여부 활성화
  const navigate = useNavigate();

  const headers = ["날짜", "시간", "사업장", "배송상태"]; // 화물추적에서 배송정보 테이블 Header

  // TODO 이미지 호출 시 API
  const { mutate: getImg } = useGetImgUrl();

  // NOTE 화물추적 테이블 열 생성 함수
  const InfoRow = ({ title, value }) => (
    <tr>
      <S.TableData colSpan={2}>{title}</S.TableData>
      <S.TableData colSpan={2}>{value || ""}</S.TableData>
    </tr>
  );
  // NOTE 화물추적 테이블 열 생성 함수
  const InfoDoubleRow = ({ title1, value1, title2, value2 }) => (
    <tr>
      <S.TableData>{title1}</S.TableData>
      <S.TableData>{value1 || ""}</S.TableData>
      <S.TableData>{title2}</S.TableData>
      <S.TableData>{value2 || ""}</S.TableData>
    </tr>
  );

  // NOTE 영상추적 버튼 클릭 시 실행되는 함수
  const handleVass = () => {
    setIsInvoice(true); // 영상추적 여부 활성화
    navigate("/vass"); // 영상추적 페이지로 이동
  };

  // NOTE 이미지 조회 버튼 클릭 시
  const handleImg = () => {
    getImg();
  };

  // NOTE 문자열 일부 *로 처리
  const maskValue = (value, maskLength = 1) =>
    value
      ? value.slice(0, maskLength) +
        "*".repeat(Math.max(0, Math.min(3, value.length - maskLength)))
      : "";

  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        <PrimeReactProvider>
          <BarcodeListsComponent theme={props.theme} />
        </PrimeReactProvider>
      </S.ContentContainer>
      {login.company === "LOGEN" && (
        <S.ListContainer>
          <S.ListHeader>
            <h4>화물추적</h4>
          </S.ListHeader>
          {/* 조회된 운송장 중 하나 클릭 시 */}
          {orderInfoIsView && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "0 20px",
                }}
              >
                {/* 해당 점소가 영상추적 기능이 활성화되어 있을 시 영상추적 버튼 띄우기 */}
                {login.camUsable === "2" && (
                  <S.Button onClick={handleVass}>영상추적하기</S.Button>
                )}
                {/* 이미지가 존재할 시 이미지 보기 버튼 띄우기 */}
                {barcodeData.find(
                  (data) => data.barcode === trackingValue.barcode
                )?.img_exists === true && (
                  <S.Button onClick={handleImg}>이미지 보기</S.Button>
                )}
              </div>
              <S.ListInfoContainer>
                <nav>
                  <h5>물품정보</h5>
                </nav>
                <S.Table>
                  <tbody>
                    <InfoRow
                      title="운송장 번호"
                      value={trackingList.relation_list?.[0]?.iv_no_relation}
                    />
                    <InfoRow
                      title="상품명"
                      value={maskValue(trackingList.goods_nm, 2)}
                    />
                    <InfoRow
                      title="보내시는 분"
                      value={maskValue(trackingList.cust_nm)}
                    />
                    <InfoRow
                      title="받으시는 분"
                      value={maskValue(trackingList.dv_nm)}
                    />
                    <InfoRow
                      title="주소"
                      value={trackingList.dv_address_jibun}
                    />
                    <InfoDoubleRow
                      title1="집하일자"
                      value1={trackingList.pick_date}
                      title2="전송수량"
                      value2={trackingList.qa}
                    />
                    <InfoDoubleRow
                      title1="배송지점"
                      value1={trackingList.dv_trade_nm}
                      title2="집하지점"
                      value2={trackingList.pick_trade_nm}
                    />
                  </tbody>
                </S.Table>
                <hr />
                <nav>
                  <h5>배송정보</h5>
                  <S.Table>
                    <thead>
                      <tr>
                        {headers.map((header, index) => (
                          <S.TableHeader key={index}>{header}</S.TableHeader>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {trackingList.trace_list?.map((item, index) => (
                        <tr key={index}>
                          <S.TableData>{item.scan_date || ""}</S.TableData>
                          <S.TableData>{item.scan_time || ""}</S.TableData>
                          <S.TableData>{item.trade_nm || ""}</S.TableData>
                          <S.TableData>{item.state_nm || ""}</S.TableData>
                        </tr>
                      )) || (
                        <tr>
                          <td colSpan={headers.length}>
                            배송정보 조회내역이 존재하지 않습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </S.Table>
                </nav>
                <hr />
                <nav>
                  <h5>배송 영업소 정보</h5>
                </nav>
                <S.Table>
                  <tbody>
                    <InfoRow
                      title="최종 처리시간"
                      value={`${
                        trackingList.trace_list?.[
                          trackingList.trace_list.length - 1
                        ]?.scan_date || ""
                      } ${
                        trackingList.trace_list?.[
                          trackingList.trace_list.length - 1
                        ]?.scan_time || ""
                      } ${
                        trackingList.trace_list?.[
                          trackingList.trace_list.length - 1
                        ]?.state_nm || ""
                      }`}
                    />
                    <InfoRow
                      title="배송 예정시간"
                      value={
                        trackingList.trace_list?.[
                          trackingList.trace_list.length - 2
                        ]?.dv_time_nm
                      }
                    />
                    <InfoRow
                      title="최종 처리 사업장"
                      value={
                        trackingList.trace_list?.[
                          trackingList.trace_list.length - 1
                        ]?.trade_nm
                      }
                    />
                    <InfoRow
                      title="연락처"
                      value={trackingList.dv_tradesub_tel}
                    />
                    <InfoRow
                      title="영업사원"
                      value={trackingList.dv_tradesub_nm}
                    />
                  </tbody>
                </S.Table>
              </S.ListInfoContainer>
            </>
          )}
        </S.ListContainer>
      )}
    </S.DashboardContainer>
  );
}

export default Barcode;
